import React, { Component } from "react";
import { styled } from "@mui/system";
import { withRouter } from "react-router-dom";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import {
  Box,
  Button,
  Typography,
  Grid,
  Autocomplete,
  TextField,
  CircularProgress,
} from "@mui/material";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "../CommonComponents/RightDrawer";
import { toastAlert } from "../../helpers/toastAlert";
import { asCustomerList, getCustomers } from "../../services/customerService";
import { getEmployees as fetchEmployeesApi } from "../../services/employeeService";
import {
  toggleModal,
  handleChange,
  toggleEditModal,
  getTasks as fetchTasksApi,
  addTask as submitAddTaskApi,
  editTask as submitEditTaskApi,
} from "../../services/taskService";
import { connect } from "react-redux";
import Task from "./task";
import TaskView from "./taskView";
import FileUploader from "../CommonComponents/FileUploader";
import CompanySelect from "../CommonComponents/CompanySelect";
import { getMasters, normalizeMasterItems } from "../../services/masterService";
import { FALLBACK_TASK_PRIORITY, FALLBACK_TASK_STATUS } from "../../utils/masterFallbacks";
import {
  TASK_TYPE_OPTIONS,
  requiredDocsForTaskType,
} from "../../utils/taskSubmissionDefaults";
import "./style.css";
import { hasPermission, canAssignStaff } from "../../utils/commonutils";

class KubanComp extends Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      data: {
        tasks: {},
        columns: {
          pending: {
            id: "pending",
            title: "Pending",
            taskIds: [],
          },
          inProgress: {
            id: "inProgress",
            title: "In Progress",
            taskIds: [],
          },
          completed: {
            id: "completed",
            title: "Completed",
            taskIds: [],
          },
        },
        columnOrder: ["pending", "inProgress", "completed"],
      },
      page: 1,
      rowsPerPage: 10,
      count: 1,
      priorityData: FALLBACK_TASK_PRIORITY.map((item) => ({
        name: item.label,
        value: item.value,
      })),
      statusData: FALLBACK_TASK_STATUS.map((item) => ({
        name: item.label,
        value: item.value,
      })),
      taskTypeData: TASK_TYPE_OPTIONS,
      customerData: [],
      employeeData: [],

      // add task values
      addModel: false,
      addError: [],
      addName: "",
      addDescription: "",
      addPriority: null,
      addStatus: null,
      addDeadline: "",
      addCustomerId: null,
      addEmployeeId: null,
      addFiles: [],
      addTaskType: { name: "Other", value: "Other" },
      addRequiredDocumentTypes: [],

      // edit task values
      editModel: false,
      editError: [],
      editId: "",
      editName: "",
      editDescription: "",
      editPriority: null,
      editStatus: null,
      editDeadline: "",
      editCustomerId: null,
      editEmployeeId: null,
      editFiles: [],
      editTaskType: { name: "Other", value: "Other" },
      editRequiredDocumentTypes: [],

      // task view
      isViewModelOpen: false,
      selectedTaskId: "",
    };
  }

  closeAddModal = () => {
    this.setState({
      addModel: false,
      addError: [],
      addName: "",
      addDescription: "",
      addPriority: null,
      addStatus: null,
      addDeadline: "",
      addCustomerId: null,
      addEmployeeId: null,
      addFiles: [],
      addTaskType: { name: "Other", value: "Other" },
      addRequiredDocumentTypes: [],
    });
  };

  closeEditModal = () => {
    this.setState({
      editModel: false,
      editError: [],
      editId: "",
      editName: "",
      editDescription: "",
      editPriority: null,
      editStatus: null,
      editDeadline: "",
      editCustomerId: null,
      editEmployeeId: null,
      editFiles: [],
      editTaskType: { name: "Other", value: "Other" },
      editRequiredDocumentTypes: [],
    });
  };

  loadTaskMasters = async () => {
    const toOptions = (items, fallback) =>
      (items.length ? items : fallback).map((item) => ({
        name: item.label,
        value: item.value,
        meta: item.meta || {},
      }));

    try {
      const [priRes, staRes, typeRes] = await Promise.all([
        getMasters(this.props, "task_priority"),
        getMasters(this.props, "task_status"),
        getMasters(this.props, "task_type"),
      ]);
      const priItems = normalizeMasterItems(priRes);
      const staItems = normalizeMasterItems(staRes);
      const typeItems = normalizeMasterItems(typeRes);
      this.setState({
        priorityData: toOptions(priItems, FALLBACK_TASK_PRIORITY),
        statusData: toOptions(staItems, FALLBACK_TASK_STATUS),
        taskTypeData: typeItems.length
          ? typeItems.map((item) => ({
              name: item.label,
              value: item.value,
              meta: item.meta || {},
            }))
          : TASK_TYPE_OPTIONS,
      });
    } catch (error) {
      this.setState({
        priorityData: toOptions([], FALLBACK_TASK_PRIORITY),
        statusData: toOptions([], FALLBACK_TASK_STATUS),
        taskTypeData: TASK_TYPE_OPTIONS,
      });
    }
  };

  getTasks = async () => {
    try {
      console.log("getTasks function ");
      await this.loadTaskMasters();
      let tasks = await fetchTasksApi(this.props, 1, 10000000000);
      console.log("getTasks fetch data", tasks);
      // // passed props to getUsers function so it can redirect this props to clearCookie() function
      if (tasks && tasks?.data?.tasks !== null) {
        this.setState({
          data: tasks?.data?.tasks,
          loading: false,
        });
      } else {
        // error
        console.log("error fetching tasks : ", tasks, tasks?.message);
        let message =
          tasks && tasks?.message !== undefined
            ? tasks?.message
            : "Problem Fetching Records.";
        toastAlert(message, "error");
        this.setState({ loading: false });
      }
    } catch (error) {
      console.log("error catch block", error);
      toastAlert("Please check Internet Connection.", "error");
      this.setState({ loading: false });
    }
  };

  addTask = async () => {
    const {
      addName,
      addDescription,
      addPriority,
      addStatus,
      addDeadline,
      addCustomerId,
      addEmployeeId,
    } = this.state;
    let error = [];

    if (!addName.trim()) {
      error.push("addName");
    }
    if (!addDescription.trim()) {
      error.push("addDescription");
    }
    if (!addPriority) {
      error.push("addPriority");
    }
    if (!addStatus) {
      error.push("addStatus");
    }
    if (!addDeadline) {
      error.push("addDeadline");
    }
    if (!addEmployeeId) {
      error.push("addEmployeeId");
    }
    if (!addCustomerId) {
      error.push("addCustomerId");
    }

    if (error.length > 0) {
      this.setState({
        addError: error,
      });
    } else {
      this.setState({
        addError: [],
      });
      try {
        console.log(" :->, Add Tasks", this.props);
        let res = await submitAddTaskApi(this.props, this);
        console.log("Add Task Response:", res.data, res.status);
        if (res && res?.status == 201) {
          toastAlert(
            res?.message ? res?.message : "Task created successfully",
            "success"
          );
          this.closeAddModal();
          this.getTasks();
        } else {
          // error
          console.log("error adding service category : ", res, res.message);
          let message =
            res && res.message !== undefined
              ? res.message
              : "Problem while adding Records.";
          toastAlert(message, "error");
          this.closeAddModal();
        }
      } catch (error) {
        console.log("error catch block", error);
        toastAlert("Please check Internet Connection.", "error");
        this.closeAddModal();
      }
    }
  };

  editTask = async () => {
    const {
      editId,
      editName,
      editDescription,
      editPriority,
      editStatus,
      editDeadline,
      editCustomerId,
      editEmployeeId,
    } = this.state;
    let error = [];

    if (!editName.trim()) {
      error.push("editName");
    }
    if (!editDescription.trim()) {
      error.push("editDescription");
    }
    if (!editPriority) {
      error.push("editPriority");
    }
    if (!editStatus) {
      error.push("editStatus");
    }
    if (!editDeadline) {
      error.push("editDeadline");
    }
    if (!editEmployeeId) {
      error.push("editEmployeeId");
    }
    if (!editCustomerId) {
      error.push("editCustomerId");
    }

    if (error.length > 0) {
      this.setState({
        editError: error,
      });
    } else {
      this.setState({
        editError: [],
      });

      try {
        console.log(" :->, Edit Tasks", this.props);
        let res = await submitEditTaskApi(this.props, this);
        console.log("Edit Task Response : ", res);
        if ((res && res?.code === 201) || res?.code === 200) {
          toastAlert(
            res?.message ? res?.message : "task edited successfully",
            "success"
          );
          this.closeEditModal();
          this.getTasks();
        } else {
          // error
          console.log("error adding service category : ", res, res.message);
          let message =
            res && res.message !== undefined
              ? res.message
              : "Problem while adding Records.";
          toastAlert(message, "error");
          this.closeEditModal();
        }
      } catch (error) {
        console.log("error catch block", error);
        toastAlert("Please check Internet Connection.", "error");
        this.closeEditModal();
      }
    }
  };

  getEmployees = async () => {
    try {
      console.log("getEmployees function ", this.props);
      let employees = await fetchEmployeesApi(this.props, 1, 1000000000);
      console.log("getEmployees fetch data", employees);
      const list = Array.isArray(employees?.data?.employees)
        ? employees.data.employees
        : [];
      if (list.length) {
        this.setState({ employeeData: list });
      } else {
        console.log(
          "error fetching employees : ",
          employees,
          employees?.message
        );
        let message =
          employees && employees?.message !== undefined
            ? employees?.message
            : "Problem Fetching Records.";
        toastAlert(message, "error");
        this.setState({ employeeData: [] });
      }
    } catch (error) {
      console.log("error catch block", error);
      toastAlert("Please check Internet Connection.", "error");
      this.setState({ employeeData: [] });
    }
  };

  getCustomers = async () => {
    try {
      const customers = await getCustomers(this.props, 1, 1000000000);
      this.setState({
        customerData: asCustomerList(customers),
      });
    } catch (error) {
      console.log("error catch block", error);
      toastAlert("Please check Internet Connection.", "error");
    }
  };

  openAddModal = () => {
    this.loadTaskMasters();
    this.getEmployees();
    this.getCustomers();
    toggleModal(this);
  };

  componentDidMount() {
    this.getTasks();
    this.getEmployees();
    this.getCustomers();
  }

  handleDropDownChange = (e, val, name, action = "add") => {
    if (name === "priority") {
      if (action === "edit") {
        this.setState({
          editPriority: val,
        });
      } else {
        this.setState({
          addPriority: val,
        });
      }
    }
    if (name === "status") {
      if (action === "edit") {
        this.setState({
          editStatus: val,
        });
      } else {
        this.setState({
          addStatus: val,
        });
      }
    }
    if (name === "customer") {
      if (action === "edit") {
        this.setState({
          editCustomerId: val,
        });
      } else {
        this.setState({
          addCustomerId: val,
        });
      }
    }
    if (name === "employee") {
      if (action === "edit") {
        this.setState({
          editEmployeeId: val,
        });
      } else {
        this.setState({
          addEmployeeId: val,
        });
      }
    }
    if (name === "taskType") {
      const fromMeta = Array.isArray(val?.meta?.requiredDocuments)
        ? val.meta.requiredDocuments
        : null;
      const docs = fromMeta || requiredDocsForTaskType(val?.value);
      if (action === "edit") {
        this.setState({
          editTaskType: val,
          editRequiredDocumentTypes: docs,
        });
      } else {
        this.setState({
          addTaskType: val,
          addRequiredDocumentTypes: docs,
        });
      }
    }
  };

  // Handle task card click
  handleTaskViewClick = (taskId) => {
    console.log("task view clickced", taskId);
    this.setState({
      isViewModelOpen: true,
      selectedTaskId: taskId,
    });
  };

  // Close modal
  handleTaskViewClose = () => {
    this.setState({
      isViewModelOpen: false,
      selectedTaskId: "",
    });
  };

handleUploadSuccess = (fileId) => {
  if (this.state?.editModel) {
    console.log("Kanban Edit Upload:", fileId);

    this.setState({
      editFiles: [fileId],
    });
  } else {
    console.log("Kanban Add Upload:", fileId);

    this.setState({
      addFiles: [fileId],
    });
  }
};
handleDeleteSuccess = (fileId) => {
  if (this.state?.editModel) {
    console.log("Kanban Edit Delete:", fileId);

    this.setState({
      editFiles: [], 
    });
  } else {
    console.log("Kanban Add Delete:", fileId);

    this.setState({
      addFiles: [],
    });
  }
};


  render() {
    const {
      addModel,
      data,
      loading,
      addError,
      addName,
      addDescription,
      addPriority,
      addStatus,
      addDeadline,
      addCustomerId,
      addEmployeeId,
      addFiles,
      addTaskType,
      addRequiredDocumentTypes,

      priorityData,
      statusData,
      taskTypeData,
      customerData,
      employeeData,

      editModel,
      editError,
      editId,
      editName,
      editDescription,
      editPriority,
      editStatus,
      editDeadline,
      editCustomerId,
      editEmployeeId,
      editFiles,
      editTaskType,
      editRequiredDocumentTypes,
      isViewModelOpen,
      selectedTaskId,
    } = this.state;
    const handleDragEnd = (result) => {
      const { destination, source, draggableId } = result;

      if (!destination) return;

      if (
        destination.droppableId === source.droppableId &&
        destination.index === source.index
      ) {
        return;
      }

      const startColumn = data.columns[source.droppableId];
      const finishColumn = data.columns[destination.droppableId];

      if (startColumn === finishColumn) {
        const newTaskIds = Array.from(startColumn.taskIds);
        newTaskIds.splice(source.index, 1);
        newTaskIds.splice(destination.index, 0, draggableId);

        const newColumn = {
          ...startColumn,
          taskIds: newTaskIds,
        };

        this.setState({
          data: {
            ...data,
            columns: {
              ...data.columns,
              [newColumn.id]: newColumn,
            },
          },
        });
        return;
      }

      const startTaskIds = Array.from(startColumn.taskIds);
      startTaskIds.splice(source.index, 1);
      const newStart = {
        ...startColumn,
        taskIds: startTaskIds,
      };

      const finishTaskIds = Array.from(finishColumn.taskIds);
      finishTaskIds.splice(destination.index, 0, draggableId);
      const newFinish = {
        ...finishColumn,
        taskIds: finishTaskIds,
      };

      this.setState({
        ...data,
        columns: {
          ...data.columns,
          [newStart.id]: newStart,
          [newFinish.id]: newFinish,
        },
      });
    };

    const KanbanColumn = styled(Box)(({ theme }) => ({
      padding: "16px",
      backgroundColor: "#f5f5f5",
      borderRadius: "8px",
      minHeight: "600px",
      width: "100%",
    }));

    const filteredData = {
      ...data,
      columns: Object.keys(data?.columns).reduce((acc, columnId) => {
        const column = data.columns[columnId];
        const filteredTaskIds = column.taskIds.filter((taskId) => {
          return true;
          // return data.tasks[taskId].assignee.id === parseInt(selectedUser);
        });
        acc[columnId] = { ...column, taskIds: filteredTaskIds };
        return acc;
      }, {}),
    };
    return (
      <Box >
        {hasPermission("create_task") && (
          <Grid container>
            <Grid
              item
              lg={12}
              sm={12}
              md={12}
              xs={12}
              xl={12}
              style={{
                textAlign: "end",
                marginBottom:"24px"
              }}
            >
              <Button
                className="btn btn-colored"
                onClick={() => this.openAddModal()}
              >
                + Add New
              </Button>
            </Grid>
          </Grid>
        )}

        <div>
          <Modal isOpen={addModel} toggle={() => toggleModal(this)} size="lg">
            <ModalHeader toggle={() => toggleModal(this)} kicker="Tasks">Create task</ModalHeader>
            <ModalBody>
              <Grid container spacing={2}>
                {/* Row 1 */}
                <Grid item xs={12} sm={6}>
                  <p className="small-text">Select Company</p>
                  <CompanySelect
                    options={customerData}
                    value={addCustomerId}
                    onChange={(val) => this.handleDropDownChange(null, val, "customer")}
                    placeholder="Select company"
                  />
                  {addError?.includes("addCustomerId") && (
                    <p className="error-message">Customer shouldn't be empty</p>
                  )}
                </Grid>

                <Grid item xs={12} sm={6}>
                  <p className="small-text">Title</p>
                  <input
                    className="input-main"
                    type="Text"
                    value={addName}
                    name="addName"
                    onChange={(evt) => handleChange(evt, this)}
                    placeholder="Title"
                  />
                  {addError?.includes("addName") && (
                    <p className="error-message">Title shouldn't be empty</p>
                  )}
                </Grid>

                <Grid item xs={12} sm={6}>
                  <p className="small-text">Deadline</p>
                  <input
                    className="input-main"
                    type="Date"
                    value={addDeadline}
                    name="addDeadline"
                    onChange={(evt) => handleChange(evt, this)}
                    placeholder="Deadline"
                  />
                  {addError?.includes("addDeadline") && (
                    <p className="error-message">Deadline shouldn't be empty</p>
                  )}
                </Grid>

                {/* Row 2 */}
                <Grid item xs={12} sm={6}>
                  <p className="small-text">Select Priority</p>
                  <Autocomplete
                    name="addPriority"
                    value={addPriority || null}
                    options={priorityData || []}
                    autoHighlight
                    onChange={(e, val) =>
                      this.handleDropDownChange(e, val, "priority")
                    }
                    getOptionLabel={(option) => option?.name || ""}
                    isOptionEqualToValue={(option, value) =>
                      option?.value === value?.value
                    }
                    slotProps={{ popper: { sx: { zIndex: 20000 } } }}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.name || ""}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        className="country-dropdown"
                        {...params}
                        size="small"
                        placeholder="Select Priority"
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: "new-password",
                        }}
                      />
                    )}
                  />
                  {addError?.includes("addPriority") && (
                    <p className="error-message">Priority shouldn't be empty</p>
                  )}
                </Grid>

                <Grid item xs={12} sm={6}>
                  <p className="small-text">Select Status</p>
                  <Autocomplete
                    name="addStatus"
                    value={addStatus || null}
                    options={statusData || []}
                    autoHighlight
                    onChange={(e, val) =>
                      this.handleDropDownChange(e, val, "status")
                    }
                    getOptionLabel={(option) => option?.name || ""}
                    isOptionEqualToValue={(option, value) =>
                      option?.value === value?.value
                    }
                    slotProps={{ popper: { sx: { zIndex: 20000 } } }}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.name || ""}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        className="country-dropdown"
                        {...params}
                        size="small"
                        placeholder="Select Status"
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: "new-password",
                        }}
                      />
                    )}
                  />
                  {addError?.includes("addStatus") && (
                    <p className="error-message">Status shouldn't be empty</p>
                  )}
                </Grid>

                <Grid item xs={12} sm={6}>
                  <p className="small-text">Work type (customer app)</p>
                  <Autocomplete
                    name="addTaskType"
                    value={addTaskType || null}
                    options={taskTypeData || []}
                    autoHighlight
                    onChange={(e, val) =>
                      this.handleDropDownChange(e, val, "taskType")
                    }
                    getOptionLabel={(option) => option?.name || ""}
                    isOptionEqualToValue={(option, value) =>
                      option?.value === value?.value
                    }
                    slotProps={{ popper: { sx: { zIndex: 20000 } } }}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.name || ""}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        className="country-dropdown"
                        {...params}
                        size="small"
                        placeholder="Select work type"
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: "new-password",
                        }}
                      />
                    )}
                  />
                  {!!addRequiredDocumentTypes?.length && (
                    <p className="small-text" style={{ marginTop: 6, opacity: 0.8 }}>
                      Customer checklist: {addRequiredDocumentTypes.join(", ")}
                    </p>
                  )}
                </Grid>

                <Grid item xs={12} sm={6}>
                  <p className="small-text">Assign Employee</p>
                  <Autocomplete
                    name="addEmployeeId"
                    value={addEmployeeId || null}
                    options={employeeData || []}
                    autoHighlight
                    disabled={!canAssignStaff(this?.props?.authData?.role)}
                    onChange={(e, val) =>
                      this.handleDropDownChange(e, val, "employee")
                    }
                    getOptionLabel={(option) => option?.name || ""}
                    isOptionEqualToValue={(option, value) =>
                      String(option?._id) === String(value?._id)
                    }
                    slotProps={{ popper: { sx: { zIndex: 20000 } } }}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.name || ""}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        className="country-dropdown"
                        {...params}
                        size="small"
                        placeholder="Select Employee"
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: "new-password",
                        }}
                      />
                    )}
                  />
                  {addError?.includes("addEmployeeId") && (
                    <p className="error-message">Employee shouldn't be empty</p>
                  )}
                </Grid>

                {/* Full Width Row 3 */}
                <Grid item xs={12}>
                  <p className="small-text"> Description</p>
                  <textarea
                    className="input-main textarea"
                    value={addDescription}
                    name="addDescription"
                    rows="2 "
                    onChange={(evt) => handleChange(evt, this)}
                    placeholder=" Description"
                  />
                  {addError?.includes("addDescription") && (
                    <p className="error-message">
                      Description shouldn't be empty
                    </p>
                  )}
                </Grid>

                {/* Full Width File Uploader */}
                <Grid item xs={12}>
                  <p className="small-text">Upload Files</p>
                  <FileUploader
                    onUploadSuccess={this.handleUploadSuccess}
                    onDeleteSuccess={this.handleDeleteSuccess}
                    thisEvt={this}
                    customerId={addCustomerId?._id}
                    files={addFiles}
                  props={this.props}
                  />
                </Grid>
              </Grid>
            </ModalBody>

            <ModalFooter>
              <Button
                className="btn btn-border"
                onClick={() => toggleModal(this)}
              >
                Cancel
              </Button>
              <Button
                className="btn btn-colored"
                onClick={() => this.addTask()}
              >
                Create task
              </Button>
            </ModalFooter>
          </Modal>
        </div>
        {/* Create Task modal : end */}

        {/* Edit Task Modal : start */}
        <div>
          <Modal isOpen={editModel} toggle={() => toggleEditModal(this)} size="lg">
            <ModalHeader toggle={() => toggleEditModal(this)} kicker="Tasks">Edit task</ModalHeader>
            <ModalBody>
              <Grid container spacing={2}>
                {/* Row 1 */}
                <Grid item xs={12} sm={6}>
                  <p className="small-text">Select Company</p>
                  <CompanySelect
                    options={customerData}
                    value={editCustomerId}
                    onChange={(val) => this.handleDropDownChange(null, val, "customer", "edit")}
                    placeholder="Select company"
                  />
                  {editError?.includes("editCustomerId") && (
                    <p className="error-message">Customer shouldn't be empty</p>
                  )}
                </Grid>

                <Grid item xs={12} sm={6}>
                  <p className="small-text"> Title</p>
                  <input
                    className="input-main"
                    type="text"
                    value={editName}
                    name="editName"
                    onChange={(evt) => handleChange(evt, this)}
                    placeholder=" Title"
                  />
                  {editError?.includes("editName") && (
                    <p className="error-message">Title shouldn't be empty</p>
                  )}
                </Grid>

                <Grid item xs={12} sm={6}>
                  <p className="small-text">Deadline</p>
                  <input
                    className="input-main"
                    type="date"
                    value={editDeadline}
                    name="editDeadline"
                    onChange={(evt) => handleChange(evt, this)}
                    placeholder="Deadline"
                  />
                  {editError?.includes("editDeadline") && (
                    <p className="error-message">Deadline shouldn't be empty</p>
                  )}
                </Grid>

                {/* Row 2 */}
                <Grid item xs={12} sm={6}>
                  <p className="small-text">Select Priority</p>
                  <Autocomplete
                    name="editPriority"
                    value={editPriority || null}
                    options={priorityData || []}
                    autoHighlight
                    onChange={(e, val) =>
                      this.handleDropDownChange(e, val, "priority", "edit")
                    }
                    getOptionLabel={(option) => option?.name || ""}
                    isOptionEqualToValue={(option, value) =>
                      option?.value === value?.value
                    }
                    slotProps={{ popper: { sx: { zIndex: 20000 } } }}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.name || ""}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        className="country-dropdown"
                        {...params}
                        size="small"
                        placeholder="Select Priority"
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: "new-password",
                        }}
                      />
                    )}
                  />
                  {editError?.includes("editPriority") && (
                    <p className="error-message">Priority shouldn't be empty</p>
                  )}
                </Grid>

                <Grid item xs={12} sm={6}>
                  <p className="small-text">Select Status</p>
                  <Autocomplete
                    name="editStatus"
                    value={editStatus || null}
                    options={statusData || []}
                    autoHighlight
                    onChange={(e, val) =>
                      this.handleDropDownChange(e, val, "status", "edit")
                    }
                    getOptionLabel={(option) => option?.name || ""}
                    isOptionEqualToValue={(option, value) =>
                      option?.value === value?.value
                    }
                    slotProps={{ popper: { sx: { zIndex: 20000 } } }}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.name || ""}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        className="country-dropdown"
                        {...params}
                        size="small"
                        placeholder="Select Status"
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: "new-password",
                        }}
                      />
                    )}
                  />
                  {editError?.includes("editStatus") && (
                    <p className="error-message">Status shouldn't be empty</p>
                  )}
                </Grid>

                <Grid item xs={12} sm={6}>
                  <p className="small-text">Work type (customer app)</p>
                  <Autocomplete
                    name="editTaskType"
                    value={editTaskType || null}
                    options={taskTypeData || []}
                    autoHighlight
                    onChange={(e, val) =>
                      this.handleDropDownChange(e, val, "taskType", "edit")
                    }
                    getOptionLabel={(option) => option?.name || ""}
                    isOptionEqualToValue={(option, value) =>
                      option?.value === value?.value
                    }
                    slotProps={{ popper: { sx: { zIndex: 20000 } } }}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.name || ""}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        className="country-dropdown"
                        {...params}
                        size="small"
                        placeholder="Select work type"
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: "new-password",
                        }}
                      />
                    )}
                  />
                  {!!editRequiredDocumentTypes?.length && (
                    <p className="small-text" style={{ marginTop: 6, opacity: 0.8 }}>
                      Customer checklist: {editRequiredDocumentTypes.join(", ")}
                    </p>
                  )}
                </Grid>

                <Grid item xs={12} sm={6}>
                  <p className="small-text">Assign Employee</p>
                  <Autocomplete
                    name="editEmployeeId"
                    value={editEmployeeId || null}
                    options={employeeData || []}
                    disabled={!canAssignStaff(this?.props?.authData?.role)}
                    autoHighlight
                    onChange={(e, val) =>
                      this.handleDropDownChange(e, val, "employee", "edit")
                    }
                    getOptionLabel={(option) => option?.name || ""}
                    isOptionEqualToValue={(option, value) =>
                      String(option?._id) === String(value?._id)
                    }
                    slotProps={{ popper: { sx: { zIndex: 20000 } } }}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.name || ""}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        className="country-dropdown"
                        {...params}
                        size="small"
                        placeholder="Select Employee"
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: "new-password",
                        }}
                      />
                    )}
                  />
                  {editError?.includes("editEmployeeId") && (
                    <p className="error-message">Employee shouldn't be empty</p>
                  )}
                </Grid>

                {/* Full width: Order Description */}
                <Grid item xs={12}>
                  <p className="small-text"> Description</p>
                  <textarea
                    className="input-main textarea"
                    value={editDescription}
                    name="editDescription"
                    rows="2"
                    onChange={(evt) => handleChange(evt, this)}
                    placeholder=" Description"
                  />
                  {editError?.includes("editDescription") && (
                    <p className="error-message">
                      Description shouldn't be empty
                    </p>
                  )}
                </Grid>

                {/* Full width: File Upload */}
                <Grid item xs={12}>
                  <p className="small-text">Upload Files</p>
                  <FileUploader
                    onUploadSuccess={this.handleUploadSuccess}
                    onDeleteSuccess={this.handleDeleteSuccess}
                    thisEvt={this}
                    customerId={editCustomerId?._id}
                    files={editFiles}
                    props={this.props}
                    defaultFileId={editFiles[0]?._id || ""}
                  />
                </Grid>
              </Grid>
            </ModalBody>

            <ModalFooter>
              <Button
                className="btn btn-border"
                onClick={() => toggleEditModal(this)}
              >
                Cancel
              </Button>
              <Button
                className="btn btn-colored"
                onClick={() => this.editTask()}
              >
                Save changes
              </Button>
            </ModalFooter>
          </Modal>
        </div>
        {/* Edit Task Modal : end */}

        {/* Task View Modal : start */}
     {hasPermission("view_task") &&  <div>
          <Modal
            isOpen={isViewModelOpen}
            onClose={this.handleTaskViewClose}
            size="xl"
          >
            {selectedTaskId && (
              <TaskView
                taskId={selectedTaskId}
                handleTaskViewClose={this.handleTaskViewClose}
              />
            )}
          </Modal>
        </div>}  
        {/* Task View Modal : end */}

        {loading ? (
          <CircularProgress style={{ color: "#5F5BA8" }} size={50} />
        ) : (
          <DragDropContext onDragEnd={handleDragEnd}>
            <Grid container spacing={3}>
              {filteredData.columnOrder.map((columnId) => {
                const column = filteredData.columns[columnId];
                return (
                  <Grid item xs={12} md={4} key={column.id}>
                       <Box
                  sx={{
                    background: "#ffffff",
                    borderRadius: "16px",
                    padding: "20px",
                    boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
                    border: "1px solid #e5e7eb",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
                    }
                  }}
                  className={column.id}
                >
                     <Typography
                    variant="subtitle1"
                    sx={{
                      mb: 1,
                      fontWeight: "700",
                      fontSize: "16px",
                      color: "#1e293b",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px"
                    }}
                    className={`${column.id}-title`}
                  >
                    {column?.title === "Deliver" ? "Complted" : column?.title}
                  </Typography>
                    <Droppable droppableId={columnId}>
                      {(provided) => (
                        <KanbanColumn
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                        >
                          {column.taskIds.map((taskId, index) => {
                            const task = data.tasks[taskId];
                            return (
                              <Draggable
                                key={task.id}
                                draggableId={task.id}
                                index={index}
                              >
                                {(provided) => (
                                  <Task
                                    provided={provided}
                                    task={task}
                                    thisEvt={this}
                                    onClick={() =>
                                      this.handleTaskViewClick(task._id)
                                    }
                                  ></Task>
                                )}
                              </Draggable>
                            );
                          })}
                          {provided.placeholder}
                        </KanbanColumn>
                      )}
                    </Droppable>
                 </Box> </Grid>
                );
              })}
            </Grid>
          </DragDropContext>
        )}
      </Box>
    );
  }
}

const mapStateToProps = (state) => ({
  authData: state.authReducer,
});

export default withRouter(connect(mapStateToProps)(KubanComp));
